import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FormComponent } from './form/form.component';
import { FormControlInputComponent } from './form-control-input/form-control-input.component';
import { FormControlSelectComponent } from './form-control-select/form-control-select.component';

@NgModule({
  declarations: [
    FormComponent,
    FormControlInputComponent,
    FormControlSelectComponent,
  ],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [FormComponent],
})
export class JsonFormModule {}
